import type { ComponentProps } from 'react';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';

import { DateRangePicker } from '@/components/common/date-picker';
import { fromDateRange, toDayjsRange } from '@/lib/date';

import { FormField } from '../form-field';

type RangeBaseProps = Omit<ComponentProps<typeof DateRangePicker>, 'value' | 'onChange'>;

export type DateRangeFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = RangeBaseProps & {
  name: TName;
  control: Control<TFieldValues>;
  label?: string;
  help?: string;
  required?: boolean;
};

export function DateRangeField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({ name, control, label, help, required, ...rest }: DateRangeFieldProps<TFieldValues, TName>) {
  return (
    <FormField name={name} control={control} label={label} help={help} required={required}>
      {({ field, fieldState }) => (
        <DateRangePicker
          {...rest}
          id={name}
          style={{ width: '100%', ...rest.style }}
          status={fieldState.error ? 'error' : undefined}
          value={toDayjsRange(field.value)}
          onChange={(range) => field.onChange(fromDateRange(range))}
          onBlur={field.onBlur}
          ref={field.ref}
        />
      )}
    </FormField>
  );
}
